import BaseIcon from "./BaseIcon";
import React, { ReactElement, SVGProps } from "react";

export default function FacebookLogoIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M12 2.438A9.563 9.563 0 1 0 21.563 12 9.574 9.574 0 0 0 12 2.438m.563 17.981v-6.356H15a.563.563 0 1 0 0-1.125h-2.438V10.5a1.69 1.69 0 0 1 1.688-1.687h1.5a.563.563 0 1 0 0-1.125h-1.5a2.813 2.813 0 0 0-2.812 2.812v2.438H9a.563.563 0 1 0 0 1.125h2.438v6.356a8.438 8.438 0 1 1 1.125 0"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
